import DashboardRoutes from "./route/dashboard_routes";
import ThemeProvider from "./layout/provider/Theme";
import WebsiteRoutes from "./route/website_routes";
import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { website_store } from "./app/website_store";
import { dashboard_store } from "./app/dashboard_store";
import { ToastContainer } from "react-toastify";
import { client_store } from "./app/client_store";
import ClientRoutes from "./route/ClientRoutes";
import * as app_consts from "./constants/react_app_consts";
import { channel_actions_helper } from "./actions/actions_helper";


let login_status;
let user_type;

if (localStorage.getItem("access"))
{
  // Logs in User if Variables are present
  login_status = true;

  if (localStorage.getItem("log_cred"))
  {
    user_type = JSON.parse(localStorage.getItem("log_cred")).account_type;
  }
} else
{
  login_status = false;
  user_type = null;
}


// -------------------------------
// APP COMPONENT
// -------------------------------
const App = () => {

  const [isSignIn, setIsSignIn] = useState(login_status);
  const [account_type, setAccountType] = useState(user_type);

  useEffect(() => {
    setAccountType(user_type);
  }, [user_type]);

  // Check Auth On Load
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("access");

      if (token)
      {
        setIsSignIn(true);

        const cred = localStorage.getItem("log_cred");
        if (cred)
        {
          const parsed = JSON.parse(cred);
          setAccountType(parsed.account_type);
        }
      } else
      {
        setIsSignIn(false);
        setAccountType(null);
      }
    };

    window.addEventListener("storage", checkAuth);
    window.addEventListener("authUpdated", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("authUpdated", checkAuth);
    };
  }, []);


  // -------------------------------
  // SOCKET CONTROL
  // -------------------------------
  useEffect(() => {
    if (
      isSignIn &&
      account_type === app_consts.DASHBOARD_USER_ACCOUNT_TYPE_STRING
    )
    {
      // connect socket
      dashboard_store.dispatch(channel_actions_helper(true));
    } else
    {
      // disconnect socket
      dashboard_store.dispatch(channel_actions_helper(false));
    }
  }, [isSignIn, account_type]);

  return (
    <>
      <ThemeProvider>
        {!isSignIn ? (
          <>
            {/* Website Pages */}
            {/* Website Store */}
            <Provider store={website_store}>
              <WebsiteRoutes />
            </Provider>
          </>
        ) : (
          <>
            {/* Direct to Which Dashboard Access Based On Account Type */}
            {
              account_type === app_consts.DASHBOARD_USER_ACCOUNT_TYPE_STRING ?
                <>
                  {/* Employee Dashboard */}
                  {/* Wrapping Around Provider */}
                  <Provider store={dashboard_store}>
                    <DashboardRoutes />
                    <ToastContainer />
                  </Provider>
                </>
                :
                <Provider store={client_store}>
                  <ClientRoutes account_type={account_type} />
                  <ToastContainer />
                </Provider>
            }
          </>
        )}
      </ThemeProvider>
    </>
  );
};
export default App;